// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportEntityBundleV2MutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  pathToPrint: Types.Scalars['String']['input'];
}>;


export type ExportEntityBundleV2Mutation = { __typename?: 'Mutation', printV2: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    ExportEntityBundleV2: 'ExportEntityBundleV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ExportEntityBundleV2Document = gql`
    mutation ExportEntityBundleV2($householdId: ID!, $pathToPrint: String!) {
  printV2(input: {householdID: $householdId, relativePath: $pathToPrint}) {
    token
    expiresInSeconds
  }
}
    `;
export type ExportEntityBundleV2MutationFn = Apollo.MutationFunction<ExportEntityBundleV2Mutation, ExportEntityBundleV2MutationVariables>;

/**
 * __useExportEntityBundleV2Mutation__
 *
 * To run a mutation, you first call `useExportEntityBundleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEntityBundleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEntityBundleV2Mutation, { data, loading, error }] = useExportEntityBundleV2Mutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      pathToPrint: // value for 'pathToPrint'
 *   },
 * });
 */
export function useExportEntityBundleV2Mutation(baseOptions?: Apollo.MutationHookOptions<ExportEntityBundleV2Mutation, ExportEntityBundleV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEntityBundleV2Mutation, ExportEntityBundleV2MutationVariables>(ExportEntityBundleV2Document, options);
      }
export type ExportEntityBundleV2MutationHookResult = ReturnType<typeof useExportEntityBundleV2Mutation>;
export type ExportEntityBundleV2MutationResult = Apollo.MutationResult<ExportEntityBundleV2Mutation>;
export type ExportEntityBundleV2MutationOptions = Apollo.BaseMutationOptions<ExportEntityBundleV2Mutation, ExportEntityBundleV2MutationVariables>;